import * as React from 'react';

import { ModalFrame } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

import { addUserAction } from 'modules/tracking/providers/user-action-provider';

import './business-details-explanation-modal.scss';

applyTranslations(require('./business-details-explanation-modal.i18n.json'));

const msgKey = 'business_details_explanation_modal';

const BusinessDetailsExplanationModal = (): JSX.Element => {
  React.useEffect(() => {
    addUserAction({
      eventCategory: 'business-bank-details',
      eventAction: 'business-bank-details-access-help-modal'
    });
  }, []);

  return (
    <ModalFrame>
      <div className="business-details-explanation-modal">
        <div className="business-details-explanation-modal__title">
          {__t(`${msgKey}.title`)}
        </div>
        <div className="business-details-explanation-modal__section">
          {__t(`${msgKey}.brief`)}
        </div>
        <div className="business-details-explanation-modal__section">
          <div className="business-details-explanation-modal__section-title">
            {__t(`${msgKey}.german_based_influnecer.title`)}
          </div>
          {__t(`${msgKey}.german_based_influnecer.info`)}
        </div>
        <div className="business-details-explanation-modal__section">
          <div className="business-details-explanation-modal__section-title">
            {__t(`${msgKey}.italy_based_influnecer.title`)}
          </div>
          <div
            className="business-details-explanation-modal__sub-section"
            dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(__t(`${msgKey}.italy_based_influnecer.info`)) }}
          />
        </div>
        <div className="business-details-explanation-modal__section">
          {__t(`${msgKey}.support.part_1`)}
          <a
            onClick={() => {
              if (window.Intercom) {
                window.Intercom('showNewMessage');
              }
            }}
            className="business-details-explanation-modal__link"
          >
            chatbot
          </a>
          {__t(`${msgKey}.support.part_2`)}
          <a
            href="mailto:hello@collabary.com"
            className="business-details-explanation-modal__link"
          >
            hello@collabary.com.
          </a>
        </div>
      </div>
    </ModalFrame>
  );
};

export default BusinessDetailsExplanationModal;

